module.exports = __webpack_public_path__ + "static/img/contant_5.e9b5458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_5.jpg
// module id = sFLz
// module chunks = 0